export enum InteractionType {
    Redirect,
    Popup,
    Silent,
}
